import React,{Component} from 'react';
import API,{BASEURL} from './API';
import { Alert,Button,ButtonGroup} from 'react-bootstrap';

const SafeGuardApi = new API();
class WorkerListItem extends Component{

  constructor(props){
    super(props);
    this.changeWorker = this.changeWorker.bind(this);
    this.showInMap = this.showInMap.bind(this);
  }
  changeWorker(){
    this.props.changeWorker(this.props.worker);
  }
  
  showInMap(e){
    this.props.showInMap(this.props.worker.location,this.props.worker);
    e.stopPropagation();
    e.preventDefault();
  

    
  }

  render(){
    const imageUrl = BASEURL + "map.png";
    const timeField = this.props.worker.atWork && this.props.worker.startTime != null ? <span >klo: {new Intl.DateTimeFormat("fi-FI", {hour: "2-digit",minute: "2-digit"}).format(new Date(this.props.worker.startTime))}&nbsp;</span>: "";
    const mapButton =  this.props.worker.atWork == true && this.props.worker.location !== undefined && this.props.worker.location != null ? <span onClick={ (e) => { this.showInMap(e)}} className="btnMap"><img src={imageUrl}></img></span> : <></>;
    const alertedSpan = this.props.worker.soundNoticeGivenToWorker == true && this.props.worker.atWork == true ?  (<span> <span className="glyphicon glyphicon-alert"> &nbsp; </span> &nbsp;</span> ):<></>;
    let styleClass = "workerListItem";
    const locationUpdate = this.props.worker.atWork && this.props.worker.locationUpdateTime != null  && this.props.worker.locationUpdateTime != undefined? <span >({new Intl.DateTimeFormat("fi-FI", {hour: "2-digit",minute: "2-digit"}).format(new Date(this.props.worker.locationUpdateTime))})</span>: <></>;
    
    if(this.props.worker.atWork == true && this.props.worker.workerNotified == false){
      styleClass = "workerActiveListItem"
    }else if(this.props.worker.atWork == true && this.props.worker.workerNotified == true){
      styleClass = "workerActiveAndNotifiedListItem"
    }
    if(this.props.worker.workingPaused === true){
      
      styleClass = "workerListItemWorkingPaused";
    }

    if(this.props.worker.registered == undefined && this.props.worker.registered == null){
       styleClass = "workerListItemNotRegistered";
    }

      return (
        <li className={styleClass} id={this.props.worker.id} onClick={this.changeWorker}>
              
              {this.props.worker.workingPaused === true ? <span className="pauseButton">||</span> :""}{alertedSpan} {timeField}<span>{this.props.worker.workerName}</span>{locationUpdate}{mapButton}

        </li>
      )

  }
}
export default WorkerListItem;
